export default __webpack_public_path__ + "static/media/crypto_phones.68c6e5ed.png";